import { useTranslation } from "~contexts/I18nContext/I18nContext";
import type { LeisureTimeAccount } from "~generated";
import { decimalHoursToHoursAndMins } from "~lib/timeHelpers";
import { TimeCard } from "./TimeCard";

type LeisureTimeAccountCardProps = {
  account: LeisureTimeAccount;
};

export function LeisureTimeAccountCard({
  account,
}: LeisureTimeAccountCardProps) {
  const t = useTranslation();
  const { hours, minutes, negative } = decimalHoursToHoursAndMins(
    account.balance_hours,
  );

  return (
    <TimeCard
      label={t.leisureTimeAccount}
      hours={hours}
      minutes={minutes}
      negative={negative}
      tooltip={t.leisureTimeAccountTooltip}
    />
  );
}
